export const normalizeEmail = (email: string) => email.trim();

export const buildMailtoUrl = (email: string) =>
  `mailto:${encodeURIComponent(normalizeEmail(email))}`;

export const buildGmailComposeUrl = (email: string) =>
  `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
    normalizeEmail(email)
  )}`;

export const buildOutlookComposeUrl = (email: string) =>
  `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(
    normalizeEmail(email)
  )}`;

export const copyEmailToClipboard = async (email: string) => {
  await navigator.clipboard.writeText(normalizeEmail(email));
};
